import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

const state = {
        start:"",
        end:"",
        date:""
}
const mutations = {
    updateStart(store, new_data) {
        store.start = new_data;
    },
    updateEnd(store, new_data) {
        store.end = new_data;
    },
    updateDate(store, new_data) {
        store.date = new_data;
    }
}

export default new Vuex.Store({
    state,
    mutations
})


// WEBPACK FOOTER //
// ./src/store/index.js